export default __webpack_public_path__ + "static/experienceImg5-50ba90d0aed041c9e7d3f50dd53ce4e8.webp";